import {
  getListData,
  getDetails,
  configDetails,
  postConfig,
  createUser
} from '@/api/T1/interfaceConfig'

export default {
  namespaced: true,
  actions: {
    // 配置列表
    getListData(ctx, payload) {
      return getListData(payload).then(res => {
        if (res && res.status === 200) {
          return res
        }
      })
    },
    // 配置并发送
    postConfig(ctx, payload) {
      return postConfig(payload).then(res => {
        if (res && res.status === 200) {
          return res
        }
      })
    },

    // 查看配置 
    getDetails(ctx, payload) {
      return getDetails(payload).then(res => {
        if (res && res.status === 200) {
          return res
        }
      })
    },

    // 配置详情
    configDetails(ctx, payload) {
      return configDetails(payload).then(res => {
        if (res && res.status === 200) {
          return res
        }
      })
    },
    // 添加
    createUser(ctx, payload) {
      return createUser(payload).then(res => {
        if (res && res.status === 200) {
          return res
        }
      })
    }
  }
}
